import { useDelete } from '../../../../api/react-query';

export function useDeleteLeaveRule() {
  const {
    mutateAsync: deleteLeaveRule,
    isLoading: isDeleting,
    error,
  } = useDelete({
    url: 'engine/rule',
    apiVersion: 'v1',
    msg: 'Rule deleted successfully',
  });

  return {
    deleteLeaveRule,
    isDeleting,
    error,
  };
}
